import React from 'react';
import QRCodeGenerator from './components/QRCodeGenerator';

function App() {
  return <QRCodeGenerator />;
}

export default App;
